import { useStore } from 'vuex'

function checkActionAllowedRoles(whiteList: any) {
  const store = useStore()
  // console.log('store', store)
  const filteredListSso = whiteList.filter((role: any) => store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes(role))
  return filteredListSso.length > 0
}

export {
  checkActionAllowedRoles
}